module.exports = __webpack_public_path__ + "d3b6a8029f296141175d98be8212d1ce.pdf";